import $ from 'jquery';
import constants from 'Constants.js';
import listService from 'ListService.js'
import BasePropertyView from 'BasePropertyView.js';
import util from '../../../../service/util/Util';
import Template from 'behaviors/properties/main/print.ejs';
import undoService      from 'UndoService';
//=====================================================================
//
// An instance of this view represents a print.
//
// Casey Justus, June 6, 2016
//
//=====================================================================
const SILENT = constants.MODEL_SILENT;

class MainPrintView extends BasePropertyView {


    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #appendixUnit, #appendixSizePreset, #section' : 'updateAttributes',
            'change #pageIds' : 'updatePageSelection',
            'change input[type=text]'               : 'updateAttributes',
            'change textarea'                       : 'updateAttributes',
            'blur textarea, input[type=text]'       : 'lostFocus',
            'focus textarea, input[type=text]'      : 'getFocus',
            'change input[type=radio]'              : 'updateAttributes'
        };

        const list = this.model.get('pageIds');
        this.model.set('selectedPageIds', list.split(','), SILENT);

        // PF-8438
        if (!this.model.get('printFileName')) {
            this.model.set('printFileName', 'print', SILENT);
        }
        this.enableSpecific();

        return this;
    }

    addPages(){
        let pagesList = [];
        $('#pageIds').empty();

        listService.pageList.map( v => {
            pagesList.push(v.model.get( 'pageTitle' ));
            $('#pageIds').append('<option value="' + listService.cleanId(v.model.get('id')) + '">' + v.model.get('name') + '</option>')
        });

        _.forEach(this.model.get('selectedPageIds'), (id) => {
            $("#pageIds option[value='"+ listService.cleanId(id) +"']").attr( "selected", true );
        });
    }

    updatePageSelection() {
        let pageids = [];
        let pageidstring = '';

        $("#pageIds :selected").each(function(){
            pageids.push( listService.cleanId($(this).val()) );
            pageidstring += ',' + listService.getCleanedId($(this).val());
        });

        if (pageidstring.length > 1) {
            pageidstring = pageidstring.substring(1);
        }

        this.model.set('selectedPageIds', pageids, SILENT);
        this.model.set('pageIds', pageidstring, SILENT); // Format Used for PF Save
        this.model.trigger('change');
    }

    updateAttributes(ev) {

        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;
        let oldVal = this.model.get(propName);

        if (oldVal.toString() !== propVal.toString()) {

            if (propName === 'appendixSizePreset') {
               this.setPrefixedSize(propVal);
            }

            if(propName === 'appendixWidth' || propName === 'appendixHeight'){
            propVal = util.convertFromUnitToPixel(propVal, this.model.get('appendixUnit'), this.model.get('appendixDpi'));
            } 

            

            if(propName === 'appendixUnit' || propName === 'appendixSizePreset'){
                this.model.set( propName, propVal, SILENT );
                this.render();
            }else if (propName === 'printFileName'){ // PF-8438
                // Remove special chars
                propVal = propVal.replace(/[^a-zA-Z0-9 ]/g, "");
                this.model.set( propName, propVal, SILENT  );
                this.render();
            } else {
                this.model.set( propName, propVal, SILENT );
            }

            undoService.add({
                undo: () => {
                    if (propName === 'appendixSizePreset') {
                        this.setPrefixedSize(oldVal);
                    }
                    this.model.set(propName, oldVal, SILENT );
                    this.render();
                },
                redo:() => {
                    if (propName === 'appendixSizePreset') {
                        this.setPrefixedSize(propVal);
                    }
                    this.model.set(propName, propVal, SILENT ); 
                    this.render();      
                }
            }, constants.UNDO_PROP_CHANGE);
            
            this.enableSpecific();
        }
    }

    enableSpecific(){
        if (this.model.get('pageType') === 'specific') {
            this.model.set({specificPageDisabled: ''});
        }else {
            this.model.set({specificPageDisabled: 'disabled'});
        }
    }

    setPrefixedSize(option) {
        switch (option){
            case 'letter':
                this.model.set('appendixHeight','792',SILENT);
                this.model.set('appendixWidth','612',SILENT);
                this.model.set('appendixUnit','inch',SILENT);
                break;
            case 'legal':
                this.model.set('appendixHeight','1008',SILENT);
                this.model.set('appendixWidth','612',SILENT);
                this.model.set('appendixUnit','inch',SILENT);
                break;
            case 'executive':
                this.model.set('appendixHeight','756',SILENT);
                this.model.set('appendixWidth','522',SILENT);
                this.model.set('appendixUnit','inch',SILENT);
                break;
            case 'a4':
                this.model.set('appendixHeight','842',SILENT);
                this.model.set('appendixWidth','595',SILENT);
                this.model.set('appendixUnit','mm',SILENT);
                break;
            case 'a5':
                this.model.set('appendixHeight','595',SILENT);
                this.model.set('appendixWidth','481',SILENT);
                this.model.set('appendixUnit','mm',SILENT);
                break;
            case 'b4':
                this.model.set('appendixHeight','1001',SILENT);
                this.model.set('appendixWidth','709',SILENT);
                this.model.set('appendixUnit','mm',SILENT);
                break;
            case 'b5':
                this.model.set('appendixHeight','709',SILENT);
                this.model.set('appendixWidth','499',SILENT);
                this.model.set('appendixUnit','mm',SILENT);
                break;
            default: break;
        }
    }


    render() {
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.addPages();
        
        $("input:radio[value='"+this.model.get('pageType')+"']").attr('checked', true);
        $("option[value='"+this.model.get('section')+"']").attr( "selected", true );
        $("option[value='"+this.model.get('appendixSizePreset')+"']").attr( "selected", true );
        $("option[value='"+this.model.get('appendixUnit')+"']").attr( "selected", true );

        this.delegateEvents();
        return this;
    }
}

export default MainPrintView;
